import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchQuotationDetail } from '#/api/crmMgmt/quotation/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import QuotationCommandBar from '#/modules/crmMgmt/quotation/components/QuotationCommandBar';
import QuotationLinesSection from '#/modules/crmMgmt/quotation/components/QuotationLinesSection';
import QuotationMainInfoCard from '#/modules/crmMgmt/quotation/components/QuotationMainInfoCard';
import { getQuotationApiErrorMessage } from '#/modules/crmMgmt/quotation/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { quotationDetailQueryKey } from '#/utils/queryKeys';

const QuotationDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: quotationDetailQueryKey(id),
    queryFn: () => fetchQuotationDetail(id),
    enabled: Boolean(id),
  });

  const detail = detailQuery.data?.data;
  const refetch = () => detailQuery.refetch();

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-5xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">報價單詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.quotation}>返回列表</Link>
            </Button>
          </div>

          {detailQuery.isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {detailQuery.isError ? (
            <p className="text-sm text-destructive">
              {getQuotationApiErrorMessage(detailQuery.error, '載入報價單失敗')}
            </p>
          ) : null}

          {detail ? (
            <>
              <QuotationMainInfoCard
                detail={detail}
                actions={(
                  <QuotationCommandBar
                    key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
                    detail={detail}
                    onRefetch={refetch}
                  />
                )}
              />
              <QuotationLinesSection detail={detail} onRefetch={refetch} />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default QuotationDetailPage;
